<template>
  <span class="d-flex justify-content-between flex-wrap mb-2">
    <span class="body-2">{{ label }}</span>
    <span class="body-2">{{ value }}</span>
  </span>
</template>

<script lang="ts">
export default {
  name: 'RideInfoLine',
};
</script>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
});
</script>
